<section class="survey-outer" [class.parking-experience-list]="!isAlredyExist">
    <div class="survey-inner">
        <div class="survey-logo">
            <a><img src="../../../assets/images/truck-logo.svg" alt=""/></a>
        </div>
        <div class="survey-grey-bg" *ngIf="bookingDetailds != null">
            <h5>Survey for Previous Parking at {{bookingDetailds?.parkingLotName}}</h5>
            <p>Arrival - {{bookingDetailds?.arrival}} <span>|</span><br /> Departure - {{bookingDetailds?.departure }}</p>
        </div>       
        <div class="parking-experience-outer" *ngIf="!isAlredyExist; else dynamicData">
            <h4>How was your parking experience?</h4>
            <p >On a scale of 1-5, how likely are you to recommend parking
                at<br />
                this location to a friend?</p>
        </div>
        <ng-template #dynamicData>
       <div class="survey-feedback" *ngIf="getFeedbackMessage() as feedback">
            <img *ngIf="feedback.img" [src]="feedback.img" alt="" />
            <h4>
                <span [ngClass]="feedback.cssClass">{{ feedback.title }}</span>
                <br *ngIf="feedback.subtitle" />
                {{ feedback.subtitle }}
            </h4>  
        </div>                  
        </ng-template>   
        <form [formGroup]="surveyForm" (ngSubmit)="addSurvey()">
            <div class="survey-list-outer" *ngIf="!isAlredyExist">
                <div *ngFor="let rating of ratings" class="survey-radio-outer" (click)="selectFeedback(rating.value)">
                    <p-radioButton class="payment-method" name="rating" [value]="rating.value" formControlName="rating">
                    </p-radioButton>
                    <div class="survey-text">
                        <div class="survey-inner-text">
                            <h5>{{rating.label}}</h5> <img src="{{ rating.emoji }}" alt="{{ rating.label }}" />
                        </div>
                        <p>{{rating.desc}}</p>    

                    </div> 
                </div>
                <div class="select-btn">
                    <p-button type="submit" label="Submit Survey" class="w-100"
                        [disabled]="surveyForm.invalid"></p-button>
                </div>
            </div>
        </form>  
    </div>  
</section>                        